import React, {useEffect, useRef, useState} from "react";
import {useI18next} from "gatsby-plugin-react-i18next";

export default function LanguageSelect() {
	const {language, languages, changeLanguage} = useI18next();
	const [open, setOpen] = useState(false);
	const rootRef = useRef(null);

	useEffect(() => {
		if (!open) {
			return undefined;
		}

		function handlePointer(event) {
			if (rootRef.current && !rootRef.current.contains(event.target)) {
				setOpen(false);
			}
		}

		function handleKey(event) {
			if (event.key === "Escape") {
				setOpen(false);
			}
		}

		document.addEventListener("mousedown", handlePointer);
		document.addEventListener("keydown", handleKey);
		return () => {
			document.removeEventListener("mousedown", handlePointer);
			document.removeEventListener("keydown", handleKey);
		};
	}, [open]);

	return (
		<div className="language-select relative inline-block" ref={rootRef}>
			<button
				type="button"
				aria-label="Language"
				aria-expanded={open}
				aria-haspopup="listbox"
				onClick={() => setOpen((value) => !value)}
				className="flex items-center justify-center gap-1 w-16 h-8 m-0 mt-0 leading-none rounded-md border border-green text-sm font-semibold text-primary bg-white"
			>
				<span>{(language || "").toUpperCase()}</span>
				<svg
					className={open ? "transform rotate-180" : ""}
					width="10"
					height="6"
					viewBox="0 0 12 7"
					fill="none"
					aria-hidden="true"
				>
					<path
						d="M1.11 1.1c.15-.14.4-.14.55 0L6 5.13 10.34 1.1c.15-.14.4-.14.55 0 .15.14.15.37 0 .51L6.37 5.89a.5.5 0 0 1-.74 0L1.11 1.61a.35.35 0 0 1 0-.51Z"
						fill="#7AC142"
					/>
				</svg>
			</button>
			{open ? (
				<ul
					role="listbox"
					className="absolute top-full left-0 z-50 mt-1 w-full overflow-hidden rounded-md border border-green bg-white shadow-md py-1"
				>
					{(languages || []).map((lng) => {
						const selected = lng === language;
						return (
							<li key={lng}>
								<button
									type="button"
									role="option"
									aria-selected={selected}
									className={`w-full py-1.5 text-sm font-semibold ${
										selected
											? "bg-green text-white"
											: "text-primary hover:bg-green hover:text-white"
									}`}
									onClick={() => {
										changeLanguage(lng);
										setOpen(false);
									}}
								>
									{lng.toUpperCase()}
								</button>
							</li>
						);
					})}
				</ul>
			) : null}
		</div>
	);
}
